import { AGENCY_PREFIX_PATH } from "configs/AppConfig";
import {
  CopyOutlined,
  FileOutlined,
  FormOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import translations from "./agencyNavTranslations";
import AppLocale from "./../lang/index";

const chosenLang = AppLocale.en.locale;

const dashBoardNavTree = [
  {
    key: "clone",
    accessKey: "agency",
    path: `${AGENCY_PREFIX_PATH}/clone`,
    title: translations[0][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: CopyOutlined,
  },
  {
    key: "phone-number",
    accessKey: "agency",
    path: `${AGENCY_PREFIX_PATH}/phone-number`,
    title: translations[1][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: PhoneOutlined,
  },
  {
    key: "charting",
    accessKey: "agency",
    path: `${AGENCY_PREFIX_PATH}/charting`,
    title: translations[2][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: FileOutlined,
  },
  {
    key: "questionnaires",
    accessKey: "agency",
    path: `${AGENCY_PREFIX_PATH}/questionnaires`,
    title: translations[3][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: FormOutlined,
  },
];

const agencyNavigationConfig = [...dashBoardNavTree];

export default agencyNavigationConfig;
